// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { z } from 'zod';
import { AppPermission } from './AppPermission';

const PermissionsObject = z.object({
  isActive: z.boolean(),
  lastStartDate: z.coerce.date(),
  lastActiveEndDate: z.coerce.date(),
});

const ContractObject = z.object({
  freeTrainingSessions: z.number(),
  totalContracts: z.number(),
  permissions: z.record(z.nativeEnum(AppPermission), PermissionsObject),
});

export type ContractOverview = z.infer<typeof ContractObject>;

export function parseContractOverview(object: unknown): ContractOverview {
  return ContractObject.parse(object);
}
